// AnimatedMessage.tsx
import { motion } from "framer-motion";

export interface AnimatedMessageProps {
  children: React.ReactNode;
  delay?: number;
  animationKey?: string;
}

export default function AnimatedMessage({
  children,
  delay = 0,
  animationKey,
}: AnimatedMessageProps) {
  return (
    <motion.div
      layout="position"
      key={animationKey}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        y: { type: "spring", stiffness: 120, damping: 20, delay },
        opacity: { duration: 0.2, delay },
      }}
    >
      {children}
    </motion.div>
  );
}
